// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GuideIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GuideIcon" ref={forwardedRef} {...props}>
      <path d="M10 3.5a3 3 0 0 0-2.974 2.599A10 10 0 0 0 5.57 5.693a4.501 4.501 0 0 1 8.856 0 10 10 0 0 0-1.454.406A3 3 0 0 0 9.999 3.5" />
      <path d="M10 9.2 8.94 8.534A10 10 0 0 0 3.618 7H3v9h.844a10 10 0 0 1 4.962 1.318L10 18l1.194-.682A10 10 0 0 1 16.156 16H17V7h-.618a10 10 0 0 0-5.322 1.534zm5.5-.654v5.973a11.5 11.5 0 0 0-4.75 1.33V10.5l1.108-.696A8.5 8.5 0 0 1 15.5 8.546M9.25 10.5v5.35a11.5 11.5 0 0 0-4.75-1.331V8.546a8.5 8.5 0 0 1 3.642 1.258z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GuideIcon = /* @__PURE__ */ Object.assign(GuideIconComponent, {
  displayName: 'GuideIcon',
});
